export var mapUserResponse = function (_a) {
    var id = _a.id, email = _a.email, lang = _a.lang, name = _a.name, role = _a.role, client_id = _a.client_id, email_verified_at = _a.email_verified_at;
    return ({
        id: id,
        email: email,
        lang: lang,
        name: name,
        role: role,
        clientId: client_id,
        emailVerifiedAt: email_verified_at,
    });
};
